<template>
  <dynamic-toolbar
    :show-full-toolbar="$vuetify.breakpoint.mdAndUp"
    dense
    flat
    :menu-items="menuItems"
  />
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import DynamicToolbar from '@/components/DynamicToolbar.vue'

export default {
  name: 'LotToolbar',
  components: { DynamicToolbar },
  computed: {
    ...mapGetters({
      lot: 'lotStore/lot'
    }),
    menuItems () {
      const that = this
      let menu = []
      if (this.$store.getters.can('api.view_lot_shippinglabel')) {
        menu.push({
          title: 'Shipping Labels',
          disabled: !(this.lot?.inventory?.inventoryline_set.length !== 0),
          action: () => that.$router.push({ name: 'shipping-labels', params: { lot: this.lot } }),
          tooltip: 'Available when lot has inventory lines'
        })
      }
      if (this.lot.manifest_id && this.$store.getters.can('api.view_lotmanifest')) {
        menu.push({
          title: 'Shipping Manifest (old)',
          action: () => that.$router.push({ name: 'lot-manifest', params: { id: this.lot.manifest_id } })
        })
      }
      if (this.lot.initial_transit_manifest_id) {
        if (this.$store.getters.can('logistics.view_transitmanifest')) {
          menu.push({
            title: 'Transit Manifest',
            action: () => that.$router.push({ name: 'transit-manifest', params: { id: this.lot.initial_transit_manifest_id } })
          })
        }
      } else if (this.$store.getters.can('logistics.add_transitmanifest')) {
        menu.push({
          title: 'New Transit Manifest',
          action: () => that.$router.push({ name: 'lot-create-manifest', params: { id: this.lot.id } })
        })
      }
      if (this.$store.getters.can('api.view_advancecalculator')) {
        menu.push({
          title: 'Advance Calculator',
          action: () => that.$router.push({ name: 'advance-calculator', params: { lot: this.lot } })
        })
      }
      if (this.$store.getters.can('api.view_clientproforma')) {
        menu.push({
          title: 'Client Proforma',
          action: () => that.$router.push({ name: 'client-proforma', params: { lot: this.lot } })
        })
      }
      if (this.$store.getters.can('api.view_shipmentresult')) {
        menu.push({
          title: 'Shipment Results',
          action: () => that.$router.push({ name: 'shipment-result', params: { lot: this.lot } })
        })
      }
      if (this.$store.getters.can('api.view_internalproforma')) {
        menu.push({
          title: 'Internal Proforma',
          action: () => that.$router.push({ name: 'internal-proforma', params: { lot: this.lot } })
        })
      }
      if (this.$store.getters.can('api.view_lot_internalreport')) {
        menu.push({
          title: 'Internal Report',
          disabled: !this.lot.final_report,
          action: () => that.$router.push({ name: 'internal-report-print', params: { lot: this.lot } }),
          tooltip: 'Requires Final Report to be created.'
        })
      }
      if (this.lot.final_report) {
        if (this.$store.getters.can('api.view_finalreport')) {
          menu.push({
            title: 'Final Report',
            action: () => that.$router.push({ name: 'lot-final-report', params: { id: this.lot.final_report.id } }),
            tooltip: 'Available when Shipment Summary Attached'
          })
        }
      } else {
        if (this.$store.getters.can('api.add_finalreport')) {
          menu.push({
            title: 'Create Final Report',
            disabled: !this.lot.shipment_summary_lot,
            action: this.createFinalReport,
            tooltip: 'Available when Shipment Summary Attached'
          })
        }
      }
      return menu
    }
  },
  methods: {
    /*
    * Creates a new the final report with this shipment summary attached
    * Finally redirects to this page with the new shipment summary id
    * */
    async createFinalReport () {
      if (!this.lot.shipment_summary_lot || !this.lot.shipment_summary_lot.shipment_summary) {
        this.$store.commit('setSnackbarError', 'Could not find linked Shipment Summary')
        return
      }
      let payload = {
        shipmentsummary_set: [this.lot.shipment_summary_lot.shipment_summary.url],
        smelter: this.lot.smelter.url,
        pt_return_rate: this.lot.smelter.pt_return_rate,
        pd_return_rate: this.lot.smelter.pd_return_rate,
        rh_return_rate: this.lot.smelter.rh_return_rate
      }
      const response = await axios.post('/api/final_reports/', payload)
      return this.$router.push({ name: 'lot-final-report', params: { id: response.data.id } })
    }
  }
}
</script>
